import React from 'react'
import { BAR_COLORS } from './ChartConstants.js'

class BarChartTable {
  constructor(options) {
    if (!options) {
      this.tableId = ''
      this.displayColorKey = false
      this.colors = []
      this.chartInfo = {}
      this.barInfo = {}
      this.values = []
      return
    }

    this.tableId = options.tableId || ''
    this.displayColorKey = !!options.displayColorKey
    this.colors = options.colorArray || Object.assign([], BAR_COLORS)

    this.chartInfo = options.chartInfo || {
      title: 'name',
      chartLabel1: 'Fund',
      chartLabel2: '',
    }

    this.barInfo = options.barInfo || {
      holdingName: 'name',
      value1Key: 'fundPercent',
      value2Key: 'indexPercent',
    }

    this.values =
      options.fund && options.details ? options.fund[options.details] || {} : []
  }

  // Get the largest index from top holdings detail O(n) @returns {number}
  _getMaxValueForHoldings(holdings) {
    let maxIndex = 0

    holdings.map((holding) => {
      if (parseFloat(holding.value1) > maxIndex) {
        maxIndex = parseFloat(holding.value1)
      }
      if (holding.value2 > maxIndex) {
        maxIndex = parseFloat(holding.value2)
      }
    })

    return maxIndex
  }

  _calculateBarGraphSize(holdingsArray, maxWidth) {
    const maxIndex = this._getMaxValueForHoldings(holdingsArray)

    holdingsArray.map((holding) => {
      holding.value1Width = Math.abs(
        Math.ceil((holding.value1 / maxIndex) * maxWidth)
      )
      holding.value2Width = Math.abs(
        Math.ceil((holding.value2 / maxIndex) * maxWidth)
      )
    })
  }

  _normalizeTableData() {
    const holdings = this.values

    return holdings.map((holding) => {
      const index = holdings.indexOf(holding)

      const newHolding = {
        name: holding[this.barInfo.holdingName],
        value1: holding[this.barInfo.value1Key],
        value2: holding[this.barInfo.value2Key],
      }

      if (this.displayColorKey) {
        const colorsLength = this.colors.length

        // repeat the colors if we run out, so we modulus the color array
        newHolding.colorValue1 = this.colors[index % colorsLength]
      }

      return newHolding
    })
  }

  _renderBarChartRow(rows) {
    const progressBarStyle = {
      color: 'rgb(15, 54, 78)',
    }

    return rows.map((rowData, index) => {
      const fillStyle = {
        width: rowData.value1Width + '%',
      }

      return (
        <tr className="Table-row" key={`${rowData.name}-${index}`}>
          <td className="Table-cell">{rowData.name}</td>
          <td className="Table-cell u-textRight">{rowData.value1}</td>
          <td className="Table-cell" style={fillStyle}>
            <div className="ProgressBar" style={progressBarStyle}>
              <span
                className="ProgressBar-fill"
                style={fillStyle}
                role="presentation"
              ></span>
            </div>
          </td>
        </tr>
      )
    })
  }

  render() {
    // #bar-chart-table-template, #bar-chart-template
    const items = this._normalizeTableData()

    this._calculateBarGraphSize(items, 100)

    return (
      <table className="Table Table--reversed Table--striped">
        <thead className="Table-head">
          <tr className="Table-row">
            <th className="Table-header u-alignMiddle u-md-size3of6 u-lg-size3of6">
              {this.chartInfo.title}
            </th>
            <th className="Table-header u-alignMiddle u-textRight">
              {' '}
              {this.chartInfo.chartLabel1}
            </th>
            <th className="Table-header u-alignMiddle"></th>
          </tr>
        </thead>
        <tbody className="Table-body">{this._renderBarChartRow(items)}</tbody>
      </table>
    )
  }
}

export default BarChartTable
